import React, { ReactElement } from 'react';
import { Loader } from 'idsk-react-components';
import PripomienkaDetailComponent from './component/PripomienkaDetailComponent';
import { ClientStatus } from '../../model/ClientStatus';
// eslint-disable-next-line import/no-named-default
import { default as PripomienkaDetailModel } from '../../model/pripomienka/PripomienkaDetail';
import VyhodnotenieDetailSection from './component/VyhodnotenieDetailSection';
import ClassType from '../../model/pripomienka/ClassType';
import ConfirmAction from '../ConfirmAction/ConfirmAction';

interface Props {
  pripomienkaDetail: PripomienkaDetailModel;
  status: ClientStatus;
  reloadPripomienkaDetail(): void;
  classType: ClassType;
}

const PripomienkaDetail = ({
  pripomienkaDetail, status, reloadPripomienkaDetail,
  classType,
}: Props): ReactElement => (
  <Loader loading={status.loading}>
    <>
      <ConfirmAction />
      <PripomienkaDetailComponent
        pripomienkaDetail={pripomienkaDetail}
      />
      <VyhodnotenieDetailSection
        classType={classType}
        pripomienkaDetail={pripomienkaDetail}
        reloadPripomienkaDetail={reloadPripomienkaDetail}
      />

    </>
  </Loader>
);

export default PripomienkaDetail;
